import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/outline';
import { FaTimesCircle } from 'react-icons/fa';
import { ordersApi } from '../../services/api/orders.api';

export default function PaymentError() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const orderId = searchParams.get('order_id');
    const [errorDetails, setErrorDetails] = useState(null);

    useEffect(() => {
        if (!orderId) {
            navigate('/');
            return;
        }

        ordersApi.getOrder(orderId)
            .then(response => {
                setErrorDetails(response);
            })
            .catch(error => {
                console.error('خطأ في جلب تفاصيل الطلب:', error);
            });
    }, [orderId, navigate]);

    const handleRetry = () => {
        navigate('/cart');
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-6 flex flex-col justify-center">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 my-auto">
                {/* الفاتورة المقصوصة مع تأثير ظل */}
                <div className="relative bg-white dark:bg-gray-800 shadow-2xl rounded-lg overflow-hidden" style={{ boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
                    {/* الجزء المقصوص من الأعلى - شكل مثلثات */}
                    <div className="w-full h-6 bg-gray-100 dark:bg-gray-900 overflow-hidden">
                        <div className="flex w-full justify-between">
                            {[...Array(40)].map((_, i) => (
                                <div key={i} className="w-3 h-6 bg-white dark:bg-gray-800" style={{ clipPath: 'polygon(50% 0%, 0 100%, 100% 100%)', margin: '0 -1px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}></div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="px-4 py-5 sm:p-6">
                        <div className="text-center">
                            <FaTimesCircle className="mx-auto h-16 w-16 text-red-500" />
                            <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">
                                فشلت عملية الدفع
                            </h3>
                            <div className="mt-2 space-y-1">
                                <p className="text-sm text-gray-500 dark:text-gray-400">عذراً!</p>
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                    {errorDetails?.response_message || 'يرجى التحقق من بيانات البطاقة والمحاولة مرة أخرى'}
                                </p>
                            </div>
                        </div>

                        <div className="mt-6 border-t border-dashed border-gray-200 dark:border-gray-700 pt-6">
                            <div className="space-y-4">
                                <div>
                                    <h4 className="text-base font-medium text-gray-900 dark:text-white">
                                        تفاصيل العملية
                                    </h4>
                                    <dl className="mt-2 space-y-2">
                                        <div>
                                            <dt className="inline text-sm text-gray-500 dark:text-gray-400">رقم الطلب: </dt>
                                            <dd className="inline text-sm text-gray-900 dark:text-white">{orderId}</dd>
                                        </div>
                                        <div>
                                            <dt className="inline text-sm text-gray-500 dark:text-gray-400">طريقة الدفع: </dt>
                                            <dd className="inline text-sm text-gray-900 dark:text-white">دفع إلكتروني</dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 flex justify-center space-x-4 space-x-reverse">
                            <button
                                onClick={() => navigate('/')}
                                className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            >
                                العودة للرئيسية
                            </button>
                            <button
                                onClick={handleRetry}
                                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            >
                                إعادة المحاولة
                            </button>
                        </div>
                    </div>
                    
                    {/* الجزء المقصوص من الأسفل - شكل مثلثات */}
                    <div className="w-full h-6 bg-gray-100 dark:bg-gray-900 overflow-hidden">
                        <div className="flex w-full justify-between">
                            {[...Array(40)].map((_, i) => (
                                <div key={i} className="w-3 h-6 bg-white dark:bg-gray-800" style={{ clipPath: 'polygon(50% 100%, 0 0, 100% 0)', margin: '0 -1px', boxShadow: '0 -1px 2px rgba(0,0,0,0.1)' }}></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
